import $ from 'jquery';

export var page = {
    init: function () {
        this.common();
        this.scroll();
    },
    common: function () {
        $(".content-main .content-tab-menu .btn-tab").on("click", function () {
            if ($(".content-top.mobile").is(":visible")) {
                $("html,body").stop(true, true).animate({ scrollTop: $(".content-tab").offset().top + 1 }, 200);
            }
        });
        //	if($(this).hasClass("active")) return false;
        //	btnContentTab.removeClass("active");
        //	$(".content-main .main-area").removeClass("active show").eq($(this).addClass("active").index()).addClass("active");
        //	setTimeout(function() {
        //		$(".content-main .main-area").addClass("show");
        //	}, 10);
        //	return false;
        //});

        //var btnDonationTab = $(".donation-tab .btn-tab").on("click", function() {
        //	if($(this).hasClass("active")) return false;
        //	btnDonationTab.removeClass("active");
        //	$(".donation-info .donation-area").removeClass("active").eq($(this).addClass("active").index()).addClass("active");
        //	return false;
        //});
    },
    contentTabAnimate: function () {
        if ($(".content-top.mobile").is(":visible")) 
            $("html,body").stop(true,true).animate({ scrollTop:$(".content-tab").offset().top + 1 }, 200);
    },
    scroll: function () {
        try {
            var body = $("body");
            var footer = $(".footer");
            var content = $(".content");
            var contentTab = $(".content-tab");
            var contentRight = $(".content-right");
            function scroll() {
                var getScroll = $(window).scrollTop();
                var getHeight = $(window).height();
                if (getScroll > 285) {
                    body.addClass("right-fixed");
                }
                else {
                    body.removeClass("right-fixed");
                }

                if (contentTab.offset().top < getScroll) {
                    body.addClass("tab-fixed");
                }
                else {
                    body.removeClass("tab-fixed");
                }

                var contentRightHeight = contentRight.height();
                var contentBottom = footer.offset().top;

                if ($(".content-top.mobile").is(":visible")) {
                    if (getScroll + getHeight > contentBottom) {
                        body.addClass("right-bottom");
                    }
                    else {
                        body.removeClass("right-bottom");
                    }
                }
                else {
                    if (getScroll + contentRightHeight + 20 > contentBottom - 44) {
                        body.addClass("right-bottom");
                    }
                    else {
                        body.removeClass("right-bottom");
                    }
                }
            }
            $(window).on("scroll", function () {
                scroll();
            }).on("resize", function () {
                scroll();
            });
            scroll();
        } catch (e) {
            // console.log(e);
        }
    },
    makePriceFormat: function (inputNumber) {
        return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");   
    }
};





// WEBPACK FOOTER //
// ./src/js/page.js